import { render, staticRenderFns } from "./menu-module-footer.vue?vue&type=template&id=085c057d&scoped=true"
import script from "./menu-module-footer.vue?vue&type=script&setup=true&lang=js"
export * from "./menu-module-footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./menu-module-footer.vue?vue&type=style&index=0&id=085c057d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c057d",
  null
  
)

export default component.exports